import { render, staticRenderFns } from "./InteractionEventClassification.vue?vue&type=template&id=2010725d&scoped=true&"
import script from "./InteractionEventClassification.vue?vue&type=script&lang=js&"
export * from "./InteractionEventClassification.vue?vue&type=script&lang=js&"
import style0 from "./InteractionEventClassification.vue?vue&type=style&index=0&id=2010725d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2010725d",
  null
  
)

export default component.exports